import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIndirectDependency = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_111392_2344)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12.0775 8.80556H13.6481C13.781 8.80556 13.8897 8.90556 13.8897 9.02779V13.0278C13.8897 13.15 13.781 13.25 13.6481 13.25H9.29859C9.16569 13.25 9.05696 13.15 9.05696 13.0278V9.02779C9.05696 8.90556 9.16569 8.80556 9.29859 8.80556H10.9901V7.58334H4.34499V8.80556H6.03646C6.16937 8.80556 6.2781 8.90556 6.2781 9.02779V13.0278C6.2781 13.15 6.16937 13.25 6.03646 13.25H1.68695C1.55405 13.25 1.44531 13.15 1.44531 13.0278V9.02779C1.44531 8.90556 1.55405 8.80556 1.68695 8.80556H3.25761V6.69446C3.25761 6.63335 3.31198 6.58335 3.37843 6.58335H7.12384V5.25001H5.49277C5.35987 5.25001 5.25113 5.15001 5.25113 5.02779V1.02779C5.25113 0.905572 5.35987 0.805573 5.49277 0.805573H9.84229C9.97519 0.805573 10.0839 0.905572 10.0839 1.02779V5.02779C10.0839 5.15001 9.97519 5.25001 9.84229 5.25001H8.21122V6.58335H11.9566C12.0231 6.58335 12.0775 6.63335 12.0775 6.69446V8.80556ZM5.13032 12.1945V9.86112H2.5931V12.1945H5.13032ZM9.10346 4.156H6.23167V1.76284H9.10346V4.156Z",
				fill: "currentColor"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_111392_2344",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 14,
				height: 14,
				fill: "white",
				transform: "translate(0.66748 0.027771)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgIndirectDependency);
export { ForwardRef as ReactComponent };
